import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import { actions } from '@imprivata/common-auth-logic';

// Changed upon generate
import { UsernamePassword } from '@imprivata/common-auth-ui';
import { ImprivataIdPush } from '@imprivata/common-auth-ui';
import { ImprivataIdManual } from '@imprivata/common-auth-ui';
import { Pin } from '@imprivata/common-auth-ui';
import { Otp } from '@imprivata/common-auth-ui';
import { Sms } from '@imprivata/common-auth-ui';
import { SmsEnroll } from '@imprivata/common-auth-ui';
import { TempCode } from '@imprivata/common-auth-ui';
import { ImprivataIdEnroll } from '@imprivata/common-auth-ui';
import { Password } from '@imprivata/common-auth-ui';
import { PasswordReset } from '@imprivata/common-auth-ui';
import { AuthError } from '@imprivata/common-auth-ui';
import { ChooseModality } from '@imprivata/common-auth-ui';
import { DeviceList } from '@imprivata/common-auth-ui'

import { LoadingOverlay } from '@imprivata/nucleus';
import { Footer } from '@imprivata/common-auth-ui';

class Main extends Component {
  static propTypes = {
    startSession: PropTypes.func,
    modality: PropTypes.string,
    sessionException: PropTypes.object,
    sessionStarted: PropTypes.bool,
    username: PropTypes.string,
    password: PropTypes.string,
    authenticationToken: PropTypes.string,
    complete: PropTypes.bool,
    isLoading: PropTypes.bool,
  };

  logRed = (message) => {
    console.log('%c' + new Date().toLocaleString() + ' %c' + message, 'color: #C61F2C', 'color:#000');
  };

  async componentDidMount() {
    this.startSession();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.complete && this.props.complete) {
      this.logRed(`Authentication token: ${this.props.authenticationToken}`); // eslint-disable-line
      this.sendAuthToken();
    }
    if (!this.props.sessionStarted && !this.props.sessionException) {
      await this.startSession();
    }
  }

  sendAuthToken() {
    let auth_token = document.getElementById('auth_token');
    auth_token.value = this.props.authenticationToken;
    let authForm = document.getElementById('auth_form');
    this.logRed('Sending token ' + auth_token + 'to /authToken');
    authForm.submit();
  }

  startSession = async () => {
    this.logRed(`Starting session`);
    if (!this.props.sessionStarted && !this.props.sessionException) {
      //TODO: temporary fix for Environment translation
      //UI should not concat strings to pass env parameter,
      //translation should be moved to backend,
      //idp-user-service have to set Environment variable
      let contextDataToken = document.getElementById('token').value;
      let cloudEnv = document.getElementById('cloudEnv').value;
      let ssdmEnv = document.getElementById('ssdmEnv').value;
      this.logRed(`Context token: ${contextDataToken}, Environment: ${cloudEnv}, SelfServiceEnvironment: ${ssdmEnv}`);
      this.props.startSession(contextDataToken, cloudEnv, ssdmEnv);
    }
  };


  render() {
    if (!this.props.sessionStarted && !this.props.sessionException) {
      return (
        <LoadingOverlay showOverlay />
      );
    }
    // if (['iid', 'sms', 'otp'].includes(this.props.modality) &&
    //   this.props.serverState.tempCodeAllowed &&
    //   this.props.serverState.temporaryCodeAvailable &&
    //   !this.props.manuallyProceedToTempCode &&
    //   !this.props.isDeviceManagementWorkflow) {
    //   console.log("DEFAULT TO TEMP CODE SCREEN");
    // }
    this.logRed('Modality: ' + this.props.modality);
    return (
      <div>
        <Switch>
          <Route path="/iid-manual" component={ImprivataIdManual} />
          <Route path="/iid" component={ImprivataIdPush} />
          <Route path="/otp" component={Otp} />
          <Route path="/password" component={Password} />
          <Route path="/password-reset" component={PasswordReset} />
          <Route path="/pin" component={Pin} />
          <Route path="/enrollsms" component={SmsEnroll} />
          <Route path="/enrollimprivataid" component={ImprivataIdEnroll} />
          <Route path="/sms" component={Sms} />
          <Route path="/choosemodality" component={ChooseModality} />
          <Route path="/username-password" component={UsernamePassword} />
          <Route path="/tempcode" component={TempCode} />
          <Route path="/devicelist" component={DeviceList} />
          <Route component={AuthError} />
        </Switch>
        <Footer />
        <LoadingOverlay showOverlay={this.props.isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    sessionStarted, modality, sessionException, isLoading, username, password,
    authenticationToken, complete, serverState, manuallyProceedToTempCode
  } = state.login;
  return {
    sessionStarted,
    modality,
    sessionException,
    username,
    password,
    authenticationToken,
    complete,
    isLoading,
    serverState,
    manuallyProceedToTempCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startSession: (contextDataToken, environment, selfServiceEnvironment) => {
      dispatch(actions.startSession(contextDataToken, environment, selfServiceEnvironment));
    },
  }
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Main));



// WEBPACK FOOTER //
// ./src/containers/Main.js